import { useState } from 'react';
import React from 'react';
import { PopUpPosition } from '../index';
import { CalendarPcItemVO } from '@domain/vo/calendar/CalendarPcListVO';
import { JobPostStatusType } from '@domain/constant/JobPostStatusType';

interface JobPostPopUpContextInterface {
  jobPostPopUpData: CalendarPcItemVO | null;
  jobPostingPopUpPosition: PopUpPosition | null;
  setJobPostPopUpData: (data: CalendarPcItemVO | null) => void;
  setJobPostingPopUpPosition: (position: PopUpPosition | null) => void;
}

interface filterConditionContextInterface {
  jobPostStatus: JobPostStatusType | null;
  aiScreeningYn: boolean;
  bookmarkYn: boolean;
  setJobPostStatus: (status: JobPostStatusType | null) => void;
  setAIScreeningYn: (aiScreeningYn: boolean) => void;
  setBookmarkYn: (bookmarkYn: boolean) => void;
}

interface BigCalendarContextInterface {
  jobPostPopup: JobPostPopUpContextInterface;
  filterCondition: filterConditionContextInterface;
}

export const BigCalendarContext = React.createContext<BigCalendarContextInterface>({
  jobPostPopup: {
    jobPostPopUpData: null,
    jobPostingPopUpPosition: null,
    setJobPostPopUpData: (data: CalendarPcItemVO | null) => {
      return;
    },
    setJobPostingPopUpPosition: (position: PopUpPosition | null) => {
      return;
    },
  },
  filterCondition: {
    jobPostStatus: null,
    aiScreeningYn: false,
    bookmarkYn: false,
    setJobPostStatus: (status: JobPostStatusType | null) => {
      return;
    },
    setAIScreeningYn: (aiScreeningYn: boolean) => {
      return;
    },
    setBookmarkYn: (bookmarkYn: boolean) => {
      return;
    },
  },
});

interface BigCalendarWrapProps {
  children: React.ReactNode;
}

const BigCalendarWrap = ({ children }: BigCalendarWrapProps) => {
  //공고 타입
  const [jobPostStatus, setJobPostStatus] = useState<JobPostStatusType | null>(null);
  //북마크 버튼
  const [bookmarkYn, setBookmarkYn] = useState(false);
  //역검활용 공고
  const [aiScreeningYn, setAIScreeningYn] = useState(false);

  //공고 팝업 Data
  const [jobPostPopUpData, setJobPostPopUpData] = useState<CalendarPcItemVO | null>(null);
  //공고가 열릴 좌표
  const [jobPostingPopUpPosition, setJobPostingPopUpPosition] = useState<PopUpPosition | null>(null);

  const contextData = {
    jobPostPopup: {
      jobPostPopUpData,
      jobPostingPopUpPosition,
      setJobPostPopUpData,
      setJobPostingPopUpPosition,
    },
    filterCondition: {
      jobPostStatus,
      aiScreeningYn,
      bookmarkYn,
      setJobPostStatus,
      setAIScreeningYn,
      setBookmarkYn,
    },
  };

  return <BigCalendarContext.Provider value={contextData}>{children}</BigCalendarContext.Provider>;
};

export default BigCalendarWrap;
